var _rect, _rect2, _path, _path2, _path3, _rect3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncentivizeTips(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E8F7CD"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1816_35095)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7998,
    y: 25.5645,
    width: 27.1333,
    height: 15.4,
    fill: "#DBF5B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3038 36.6595H28.3038C29.215 36.6595 30.0739 36.3043 30.7187 35.6596C31.3629 35.0154 31.718 34.1564 31.718 33.2453C31.718 31.3635 30.1866 29.8322 28.3044 29.8316L28.3044 29.8316C27.3932 29.8316 26.5343 30.1868 25.89 30.831C25.2453 31.4757 24.8902 32.3347 24.8902 33.2458L24.8902 33.2459C24.8907 35.1281 26.4215 36.6589 28.3038 36.6595ZM17.3712 35.5297L17.3712 30.9629C18.4828 30.6288 19.4048 29.7068 19.7389 28.5951L36.8688 28.5946C37.0328 29.1497 37.3336 29.6582 37.7535 30.0781C38.1735 30.498 38.6819 30.7988 39.237 30.9629L39.237 35.5278C38.6817 35.692 38.1734 35.9937 37.7541 36.413C37.3342 36.8328 37.033 37.3408 36.8688 37.896L19.738 37.8965C19.4002 36.7627 18.505 35.8674 17.3712 35.5297Z",
    fill: "#6BAA32",
    stroke: "black",
    strokeWidth: 0.511312
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1884 24.9218L15.1901 24.9218L41.418 24.9218C42.1014 24.9218 42.6582 25.4786 42.6582 26.162L42.6582 40.3384C42.6582 40.6609 42.5272 40.9767 42.2944 41.2095C42.0615 41.4423 41.7457 41.5733 41.4232 41.5733L15.1864 41.5733C15.1862 41.5733 15.1859 41.5733 15.1857 41.5733C14.5069 41.5685 13.9547 41.0163 13.9499 40.3375C13.9499 40.3373 13.9499 40.337 13.9499 40.3368L13.9499 26.162C13.9499 25.4988 14.5337 24.9174 15.1884 24.9218ZM18.8812 39.9037L18.8812 39.648L18.8812 39.9037L37.7277 39.9032C38.2818 39.9032 38.7308 39.4542 38.7308 38.9001C38.7308 38.098 39.4389 37.3913 40.2408 37.3904C40.5176 37.3903 40.7686 37.2778 40.9498 37.0966C41.1311 36.9154 41.2436 36.6642 41.2436 36.3873V30.1053C41.2436 29.8393 41.1377 29.5838 40.9498 29.396C40.7614 29.2075 40.5064 29.1022 40.2405 29.1022C39.8363 29.1022 39.458 28.9458 39.1726 28.6604C38.8872 28.375 38.7308 27.9967 38.7308 27.5925C38.7308 27.3266 38.6255 27.0716 38.4371 26.8832C38.2492 26.6953 37.9937 26.5894 37.7277 26.5894V26.8451L37.7277 26.5894L18.8812 26.5899C18.3271 26.5899 17.8781 27.0389 17.8781 27.593C17.8781 28.3954 17.1708 29.1027 16.3684 29.1027C15.8143 29.1027 15.3653 29.5517 15.3653 30.1058L15.3653 36.3878C15.3653 36.942 15.8143 37.3909 16.3684 37.3909C17.2008 37.3909 17.8781 38.0683 17.8781 38.9006C17.8781 39.1665 17.9834 39.4215 18.1719 39.61C18.3603 39.7984 18.6153 39.9037 18.8812 39.9037Z",
    fill: "#6BAA32",
    stroke: "black",
    strokeWidth: 0.511312
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.775 35.8056H28.1666V35.1673C27.3374 35.054 26.9437 34.4515 26.89 33.9444L27.6297 33.7655C27.6655 34.1413 27.916 34.4873 28.4648 34.4873C28.8526 34.4873 29.0793 34.3023 29.0793 34.0399C29.0793 33.8371 28.9301 33.682 28.6319 33.6163L28.0831 33.497C27.4388 33.3539 27.0391 32.9482 27.0391 32.3756C27.0391 31.7432 27.5283 31.2779 28.1666 31.1765V30.5382H28.775V31.1944C29.461 31.3197 29.7593 31.7969 29.8428 32.1966L29.1091 32.4054C29.0733 32.1966 28.9182 31.8506 28.429 31.8506C28.0473 31.8506 27.8385 32.0713 27.8385 32.3159C27.8385 32.5008 27.9697 32.6559 28.2501 32.7156L28.7929 32.8408C29.5446 33.0079 29.8846 33.4553 29.8846 33.9922C29.8846 34.541 29.4909 35.048 28.775 35.1614V35.8056Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1816_35095",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 6,
    width: 24,
    height: 20
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2128,
    y: 6.71255,
    width: 22.1281,
    height: 18.9187,
    fill: "#295C07",
    stroke: "black",
    strokeWidth: 0.432424
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1816_35095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.4813 12.7326H32.2535V11.5524H37.4612V15.9577H36.0136V14.0776V13.6073L35.6566 13.9135L29.5932 19.1143L25.9739 16.0098L25.8331 15.8891L25.6924 16.0098L20.193 20.7269L19.2084 19.8824L25.8336 14.1613L29.4525 17.2653L29.5925 17.3855L29.7332 17.266L34.6213 13.1136L35.0698 12.7326H34.4813Z",
    fill: "#295C07",
    stroke: "black",
    strokeWidth: 0.432424
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1816_35095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(6 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncentivizeTips);
export default __webpack_public_path__ + "static/media/Incentivize_tips.3d358d96cd44f9ea08f0c628f0100905.svg";
export { ForwardRef as ReactComponent };